module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.$route.meta.content !== '注册') ? _c('Header-list', {
    ref: "header"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "renderBody"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), _c('Footer-list', {
    ref: "footer"
  }), _vm._v(" "), _c('register-panel', {
    ref: "register"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toTopBtnShow),
      expression: "toTopBtnShow"
    }],
    staticClass: "scroll-to-top",
    on: {
      "click": function($event) {
        return _vm.scrollToTop(0.1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/return-top.svg"),
      "alt": "回到顶部"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0dc3ba0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout.vue
// module id = 364
// module chunks = 12